import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { api } from './api';
const LABELS = {
  'account.created': 'Created account',
  'account.added': 'Brought in account',
  'account.removed': 'Removed account',
  'account.deleted': 'Deleted account and its posts',
  'account.paused': 'Paused account',
  'account.active': 'Resumed account',
  'account.profile': 'Edited profile',
  'publish.discussion': 'Published discussion',
  'publish.reply': 'Published reply',
  'ai.proposed_accounts': 'AI drafted account profiles',
  'ai.drafted_persona': 'AI suggested a persona',
  'persona.saved': 'Saved persona',
  'memory.added': 'Added memory',
  'memory.edited': 'Edited memory',
  'memory.deleted': 'Deleted memory',
  'memory.imported': 'Imported past posts into memory',
  'memory.evolved': 'Updated evolving memory (AI)',
  'memory.summarised': 'Summarised older memory (AI)',
  'memory.reset': 'Reset memory',
  'draft.generated': 'AI wrote a draft',
  'draft.created': 'Started a draft',
  'draft.edited': 'Edited a draft',
  'draft.regenerated': 'AI rewrote a draft',
  'draft.approved': 'Approved a draft',
  'draft.rejected': 'Rejected a draft',
  'draft.deleted': 'Deleted a draft',
  'draft.published': 'Published a draft',
  'opportunities.refreshed': 'Refreshed suggestions',
  'opportunity.dismissed': 'Dismissed a suggestion',
  'inbox.done': 'Marked inbox item done',
  'inbox.reopened': 'Reopened inbox item',
  'draft.scheduled': 'Scheduled a draft',
  'schedule.cancel': 'Cancelled a scheduled item',
  'schedule.pause': 'Paused a scheduled item',
  'schedule.resume': 'Resumed a scheduled item',
  'schedule.retry': 'Retried a scheduled item',
  'schedule.reschedule': 'Rescheduled an item',
  'schedule.paused_all': 'Paused all publishing',
  'schedule.resumed_all': 'Resumed publishing',
  'schedule.run': 'Ran the publisher by hand',
  'conversation.generated': 'AI wrote a conversation',
  'conversation.approve': 'Approved a conversation',
  'conversation.schedule': 'Scheduled a conversation',
  'conversation.reorder': 'Reordered a conversation',
  'conversation.regenerate': 'AI rewrote a conversation',
  'conversation.deleted': 'Deleted a conversation',
  'polls.removed_managed_votes': 'Removed managed accounts\' poll votes'
};

/** Activity log: every action taken in the Engagement Centre. attrs: state */
export default class AuditTab extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.account = '';
    this.load();
  }
  load() {
    this.entries = null;
    api('GET', '/audit' + (this.account ? '?account=' + this.account : '')).then(r => this.entries = r.entries || []).catch(() => this.entries = []).finally(() => m.redraw());
  }
  link(e) {
    if (e.subjectType === 'discussion') return '/d/' + e.subjectId;
    if (e.subjectType === 'post' && e.details && e.details.discussion) return '/d/' + e.details.discussion;
    if (e.action === 'account.deleted') return null;
    if (e.subjectType === 'user' && e.account) return app.route('user', {
      username: e.account
    });
    return null;
  }
  view() {
    const accounts = this.attrs.state.accounts || [];
    return m("div", {
      className: "VEC-audit"
    }, m("label", {
      className: "VEC-field is-narrow"
    }, m("span", null, "Account"), m("select", {
      className: "FormControl",
      value: this.account,
      onchange: e => {
        this.account = e.target.value;
        this.load();
      }
    }, m("option", {
      value: ""
    }, "All accounts"), accounts.map(a => m("option", {
      value: a.userId
    }, a.displayName)))), !this.entries ? m(LoadingIndicator, null) : this.entries.length ? m("table", {
      className: "VEC-table"
    }, m("thead", null, m("tr", null, m("th", null, "When (UTC)"), m("th", null, "By"), m("th", null, "Action"), m("th", null, "Account"), m("th", null, "Details"))), m("tbody", null, this.entries.map(e => {
      const href = this.link(e);
      const detail = e.details && (e.details.title || (e.details.count != null ? e.details.count + (e.action === 'ai.proposed_accounts' ? ' profiles' : ' items') : '') || (e.details.added != null ? e.details.added + ' added, ' + e.details.flagged + ' flagged' : '') || (e.action === 'account.deleted' ? e.details.username + ' (' + e.details.discussions + ' discussions, ' + e.details.repliesElsewhere + ' other posts)' : '') || e.details.username || '');
      return m("tr", null, m("td", null, e.at), m("td", null, e.actor || '—'), m("td", null, LABELS[e.action] || e.action), m("td", null, e.account || '—'), m("td", null, href ? m("a", {
        href: href,
        target: "_blank",
        rel: "noopener"
      }, detail || 'Open') : detail || ''));
    }))) : m("p", {
      className: "VEC-empty"
    }, "Nothing yet."));
  }
}